export default __webpack_public_path__ + "eda3967a8d6d754a1c13eac420f067b0.png";